<template>
  <BottomSheetDialog
    hide-close-button
    height="variable"
    styling="padding-bottom: 0;"
    :model-value="showConfirmActivity"
    @close="confirm"
  >
    <ConfirmActivity
      @reset="reset"
      @confirm="confirm"
    />
  </BottomSheetDialog>
</template>

<script>
import { useStore } from "../stores/store";
import BottomSheetDialog from "../components/common/BottomSheetDialog.vue";
import ConfirmActivity from "../components/common/ConfirmActivity.vue";

export default {
  name: "ConfirmActivityView",
  components: {
    ConfirmActivity,
    BottomSheetDialog
  },
  setup() {
    const store = useStore()
    return {
      store
    }
  },
  computed: {
    showConfirmActivity() {
      return Boolean(this.store.showConfirmActivity)
    },
  },
  methods: {
    reset() {
      this.$emit('reset')
    },
    confirm() {
      this.$emit('confirm')
    }
  }
}
</script>

<style scoped>

</style>